import styled from "@emotion/styled";

type Size = "sm" | "xl";

export const Spinner = ({ size = "xl" }: { size?: Size }) => {
  return (
    <Ring $size={size}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </Ring>
  );
};

// This component is moulded by AI overlords to mimic @mui one, hence all those
// magic values below.
const Ring = styled.div<{ $size: Size }>`
  position: relative;
  width: ${(props) => (props.$size === "xl" ? 80 : 16)}px;
  height: ${(props) => (props.$size === "xl" ? 80 : 16)}px;

  & div {
    box-sizing: border-box;
    position: absolute;
    width: ${(props) => (props.$size === "xl" ? 64 : 16)}px;
    height: ${(props) => (props.$size === "xl" ? 64 : 16)}px;
    border: ${(props) => (props.$size === "xl" ? 4 : 2)}px solid #1d1b1b;
    border-radius: 50%;
    animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1d1b1b transparent transparent transparent;
  }

  & div:nth-of-type(1) {
    animation-delay: -0.45s;
  }

  & div:nth-of-type(2) {
    animation-delay: -0.3s;
  }

  & div:nth-of-type(3) {
    animation-delay: -0.15s;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
